<template>
    <v-card class="slide-card-up" :color="colorFondo" outlined>
        <v-list dense nav color="transparent">
            <v-list-item v-for="opcion in opciones" :key="opcion.id" link
                @click="$emit('seleccionar', opcion.id)"
                :class="{ 'menu-lateral-activo': opcion.id === activo }">
                <v-list-item-icon>
                    <v-icon :color="opcion.id === activo ? colorActivo : 'grey darken-1'">
                        {{ opcion.icono }}
                    </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ opcion.titulo }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider class="my-2"></v-divider>

            <v-list-item link @click="$emit('cerrar-sesion')">
                <v-list-item-icon>
                    <v-icon color="red darken-2">mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title class="red--text text--darken-2">Cerrar sesión</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
export default {
    name: 'MenuLateralCentralReservas',
    props: {
        opciones: {
            type: Array,
            required: true
        },
        activo: {
            type: String,
            required: true
        },
        colorFondo: {
            type: String,
            default: '#FBFAF1'
        },
        colorActivo: {
            type: String,
            default: '#191970'
        }
    }
}
</script>

<style scoped>
.menu-lateral-activo {
    background-color: rgba(25, 25, 112, 0.12);
    border-left: 4px solid #191970;
}
</style>
